import { isJSON } from '@app/utils/json';

export interface WebSocketEventItem {
  name: string;
  payload: unknown;
  userId?: string;
}

export interface WebSocketMessageDetail {
  payload?: unknown;
}

/**
 * Returns the payload array from a WebSocket message event if it is a valid array; otherwise null.
 * Single place for the shape of detail.payload and the array guard.
 */
export function getWebSocketPayloadArray(
  messageEvent: { detail?: WebSocketMessageDetail } | null | undefined,
): WebSocketEventItem[] | null {
  const payload = messageEvent?.detail?.payload;
  return Array.isArray(payload) ? payload : null;
}

/**
 * Parses event payload: if it's a JSON string, parse it; otherwise return as-is.
 */
export function parseEventPayload(payload: unknown): unknown {
  return isJSON(payload) ? JSON.parse(payload as string) : payload;
}
